export type TagsIndexComponentProps = Record<string, never>

/** Placeholder — this route redirects server-side before render */
export function TagsIndexComponent(_props: TagsIndexComponentProps) {
  return <div />
}
